import App from './App.svelte';
import BendService from "./services/BendService";
import openpgp from 'openpgp/dist/openpgp';

BendService.configure('63K1RVaGQf20E4r7Kbh8AA', '7Pl3lUtCo9ZGpfNL7srxrMZ5exPV1Pw7gEb64uJ7');

const app = new App({
	target: document.body,
	props: {
		name: 'world'
	}
});



export default app;